export default __webpack_public_path__ + "static/char-s-07-en-28896bd2b2340b45d3363ecdae63f80c.webp";